import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { PrButtonModule } from '../pr-button/pr-button/pr-button.module';
import { PrIconModule } from '../pr-icon/pr-icon.module';
import { PrLoaderModule } from '../pr-loader/pr-loader.module';
import { PrModalModule } from '../pr-modal/pr-modal.module';
import { PrSearchInputModule } from '../pr-search-input/pr-search-input.module';

import { GedPickerComponent } from './ged-picker.component';

@NgModule({
  declarations: [GedPickerComponent],
  imports: [
    CommonModule,
    FormsModule,
    PrButtonModule,
    PrIconModule,
    PrLoaderModule,
    PrModalModule,
    PrSearchInputModule,
  ],
  exports: [GedPickerComponent],
})
export class PrGedPickerModule {}
